// This icon file is generated automatically.
var PSwapRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.64 7.32L9.08 4.07a.5.5 0 00-.4-.2h-1c-.11 0-.17.13-.1.2l2.25 2.87H.37a.13.13 0 00-.12.12V8c0 .07.06.13.13.13h10.87a.5.5 0 00.4-.81z", "fill-rule": "nonzero" } }] }, "name": "p-swap-right", "theme": "outlined" };
export default PSwapRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSwapRightOutlined.js
// module id = 3666
// module chunks = 0